// extracted by mini-css-extract-plugin
export default {"loadingMask-page":"loadingMask_loadingMask-page__sWYoW","loadingMask-section":"loadingMask_loadingMask-section__sb6qk","flexCenter":"loadingMask_flexCenter__3hieu"};